module.exports = __webpack_public_path__ + "img/activation-step.9814f9c6.png";